import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getActionAuthorizationStatus = unaryRpc({
  name: "getActionAuthorizationStatus",
  input: z.object({ token: z.string().min(1) }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal("pending"), expiresAt: z.date() }),
    z.object({ status: z.literal("already_confirmed") }),
    z.object({ status: z.literal("expired_or_unknown") }),
  ]),
});
